/**
 * /particuliers/aides/tva-reduite
 * ─────────────────────────────────────────────────────────────────
 * Guide éditorial complet (long-form) sur la TVA à 5,5 % pour les
 * travaux d'amélioration énergétique.
 *
 * Composé du composant `TvaReduiteGuide` (hero, mécanisme, comparatif
 * 5,5/10/20 %, travaux éligibles, conditions, pièges, cumul, FAQ, CTA).
 *
 * Contenu factuel : `client/src/config/tva-reduite-content.ts`.
 */

import { TvaReduiteGuide } from '../../../../components/aides/TvaReduiteGuide';

export default function TvaReduitePage() {
  return <TvaReduiteGuide />;
}
